import http from "../http";

const ScheduleService = {

    getScheduleFlights: async (SearchDate) => {
        const config = {
            params: {date: SearchDate}
        }
        const schedule = await http.instance.get("/Schedule",config );
        return schedule.data;
    },

    // getScheduleFlightsstatic:  (SearchDate) => {
    //     const schedule = http.instance.get("/Schedule", {params: {date: SearchDate}});
    //     return schedule.data;
    // },


    getOccVersionInfoByKFZ: async (KFZ) => {
        const verInfo = await http.instance.get("/Schedule/GetOccVersionsByKFZ", {params: {KeyForZip: KFZ}});
        console.log("getOccVersionInfoByKFZ: " + verInfo.data)
        return verInfo.data;
    },

    getFlightsTimeSpan: async (SearchDate) => {
        try {
            const config = {
                params : {date: SearchDate}
            }

            const timeSpan =await http.instance.get("/Schedule/GetFlightCheckChanges", config);
            return timeSpan.data;
        }
        catch (e) {
            this.$notify({title: "Error", text: "Error on getFlightsTimeSpan function"+ "DB connection could be refused ,"+SearchDate+" e: "+e.message, type: "error"})
            //console.log("DB connection refused ,"+SearchDate +": "+ e.message);
        }
    },

    getAllUsers : async()=>{
        try {
            const flights =await http.instance.get("/Schedule/GetAllUsers");
            return flights.data;
        }
        catch (e) {
            this.$notify({title: "Error", text: "Error on getAllUsers function, "+ e.message, type: "error"})
        }
    },

    getAllRoles : async()=>{
        try {
            const roles = await http.instance.get("/Schedule/GetRoles");
            return roles.data;
        }
        catch(e)
        {
            console.log(e.message);
            //this.$notify({title: "Error", text: "Error on getAllRoles function, " + e.message, type: "error"})
        }

    },

    /*
        getFlightsTimeSpan: async (SearchDate) => {

            try {
                const timeSpan = await http.instance.get("/Schedule/GetFlightCheckChanges", {params: {date: SearchDate}});
                return timeSpan.data;
            }
            catch (e) {
                console.log("DB connection refused ,"+SearchDate +": "+ e.message);
            }
        },
    */

    getFlightNotesByLegNo : async (LEG_NO) => {
        try {
            const flightNotes = await http.instance.get("/Schedule/GetNetlineFlightNotesByLEGNO", {params: {legNo: LEG_NO}});
            return flightNotes.data;
        }
        catch (e) {
            console.log("getFlightNotesByLegNo couldn't get notes , LegNo:"+LEG_NO +": "+ e.message);
        }
    },

    // kullanılmıyor silinecek...
    // InsertFlightNoteForm : async (form) => {
    //     const edit = await http.instance.post("/Schedule/InsertFlightNote", form);
    //     return edit.data;
    // },

    InsertOrUpdateFlightNoteForm : async (form) => {
        const edit = await http.instance.post("/Schedule/InsertOrUpdateFlightNote", form);
        return edit.data;
    },

    DeleteFlightNoteForm : async (form) => {
        const deleteResponse = await http.instance.post("/Schedule/DeleteFlightNote", form);
        return deleteResponse.data;
    },

    getAttachmentByFlights: async (KeyForNetline) => {
        const attachmentFlight = await http.instance.get('/Attachment/getattachmentsbyflight/', {params: {LastKeyForNetline: KeyForNetline}});
        return attachmentFlight.data;
    },

    getDeleteAttachments: async (KeyForNetline) => {
        //console.log("getDeletedAttachments: "+ KeyForNetline);
        const deleteAttachments = await http.instance.get("/Attachment/DeletedAttachments/", {params: {LastKeyForNetline: KeyForNetline}});
        return deleteAttachments.data;
    },

    ForceUpdateNetlineIntegrationService: async() => {
        const Response = await http.instance.post("/Schedule/ForceUpdateNetline",);
        return Response.data;
    },

    NeedReplaceForFileUpload_SpecialFunc: async(FKeyForZip,RealName,AttachmentTypeId,LastKeyForNetline,UploadedBy,CreatedAt,ModifiedAt) => {
        // ISATTACHMENTMASTER
        const attachment = new FormData();

        attachment.set("FKeyForZip", FKeyForZip);
        attachment.set("AttachmentTypeId" , AttachmentTypeId);
        attachment.set("RealName" , RealName);
        attachment.set("LastKeyForNetline",LastKeyForNetline);

        attachment.set("UploadedBy",UploadedBy.fullName);
        attachment.set("CreatedAt",CreatedAt);
        attachment.set("ModifiedAt",ModifiedAt);




        const response = http.instance.post("/AttachmentSpecialF/NeedReplaceForFileUpload_SpecialFunc/",attachment);
        //console.log("response.data : " + response.data);
        return response;
    },

    NeedReplaceForFileUpload: async (FKeyForZip, RealName, AttachmentTypeId, LastKeyForNetline) => {
        try {
            const attachment = new FormData();
    
            attachment.set("FKeyForZip", FKeyForZip);
            attachment.set("AttachmentTypeId", AttachmentTypeId);
            attachment.set("RealName", RealName);
            attachment.set("LastKeyForNetline", LastKeyForNetline);
    
            const response = await http.instance.post("/attachment/NeedReplaceForFileUpload/", attachment);
            
            console.log("response:", response);
            return response;
        } catch (error) {
            console.error("Error:", error.response ? error.response : error.message);
            throw error;
        }
    },
    

    setFileUpload_SpecialFunc: async(files , FKeyForNetline , fileNote , selectedAttachmentType , Std , AttachmentId , ALVT , KeyForZip,UploadedBy,CreatedAt,ModifyAt) => {
        // ISATTACHMENTMASTER
        const Files = new FormData();
        Files.append("Files", files);
        const response = http.instance.post("/AttachmentSpecialF/UploadFileSpecialFunc", Files,
            {
                headers: {'Content-Type': 'multipart/form-data'},
                params: {
                    AttachmentId: AttachmentId,
                    ALVT: ALVT,
                    LastKeyForNetline: FKeyForNetline,
                    FKeyForZip : KeyForZip,
                    AttachmentTypeId : selectedAttachmentType,
                    descriptionUser : fileNote,
                    Std : Std,
                    UploadedBy:UploadedBy,
                    CreatedAt:CreatedAt,
                    ModifyAt:ModifyAt

                },
            });
        return response
    },

    setFileUpload: async(files , FKeyForNetline , fileNote , selectedAttachmentType , Std , AttachmentId , ALVT , KeyForZip) => {
        const Files = new FormData();
        Files.append("Files", files);
        console.log("here....");
        let response = http.instance.post("/attachment/UploadFile", Files,
            {
                headers: {'Content-Type': 'multipart/form-data'},
                params: {
                    AttachmentId: AttachmentId,
                    ALVT: ALVT,
                    LastKeyForNetline: FKeyForNetline,
                    FKeyForZip : KeyForZip,
                    AttachmentTypeId : selectedAttachmentType,
                    descriptionUser : fileNote,
                    Std : Std
                },
            });
            response = JSON.stringify(response, null, 2);
            console.log('res:' + response);
        return response
    },

    deleteDocument_SpecialFunc: async (AttachmentId,KeyForNetline,RealName,AttachmentTypeId,DeleteBy,CreatedAt,ModifyDt) =>
    {

        const deleteattachment = new FormData();

        deleteattachment.set("AttachmentId",AttachmentId);
        deleteattachment.set("LastKeyForNetLine", KeyForNetline);
        deleteattachment.set("AttachmentTypeId" , AttachmentTypeId);
        deleteattachment.set("DeletedBy" , DeleteBy);
        deleteattachment.set("RealName" , RealName);
        deleteattachment.set("CreatedAt", CreatedAt);
        deleteattachment.set("ModifiedAt", ModifyDt);

        const deletedocument =  await http.instance.post("/AttachmentSpecialF/DeleteSpecialFunc/" , deleteattachment);

        return deletedocument;

    },

    deleteDocument: async (AttachmentId,KeyForNetline,RealName,AttachmentTypeId,DeleteBy) =>
    {

        const deleteattachment = new FormData();

        deleteattachment.set("AttachmentId",AttachmentId);
        deleteattachment.set("LastKeyForNetLine", KeyForNetline);
        deleteattachment.set("AttachmentTypeId" , AttachmentTypeId);
        deleteattachment.set("DeletedBy" , DeleteBy);
        deleteattachment.set("RealName" , RealName);

        const deletedocument =  await http.instance.post("/Attachment/Delete3/" , deleteattachment);

        return deletedocument;

    },

    revertAttachment: async (AttachmentId,KeyForNetline,RealName,AttachmentTypeId,DeleteBy) => {

        const deleteattachment = new FormData();
        deleteattachment.set("AttachmentId",AttachmentId);
        deleteattachment.set("LastKeyForNetLine", KeyForNetline);
        deleteattachment.set("AttachmentTypeId" , AttachmentTypeId);
        deleteattachment.set("DeletedBy" , DeleteBy);
        deleteattachment.set("RealName" , RealName);

        const revertAttachment = await http.instance.post("/Attachment/RevertDeleteAttachment/", deleteattachment);
        return revertAttachment;

    },

    // GetJrJson : async (KFZ,STD,JLVT) =>
    // {
    //     const JRJsonData = await http.instance.get("/Attachment/GetJRjson/",{
    //           params :
    //           {
    //               KFZ : KFZ,
    //               STD : STD,
    //               JLVT : JLVT
    //           }
    //     })
    //
    //     return JRJsonData.data;
    //
    //   },

    // archive Stat
    GetWrJson : async (KFZ,STD,WLVT,archiveStat) =>
    {
        const JRJsonData = await http.instance.get("/Attachment/GetWRjson/",{
            params :
                {
                    KFZ : KFZ,
                    STD : STD,
                    WLVT : WLVT,
                    ArchiveStat : archiveStat,
                }
        })

        return JRJsonData.data;

    },



    GetWNReqJetPDataService : async (KFZ,STD,WLVT,ArchiveStat) =>
    {

        const JRJsonData = await http.instance.get("/Attachment/GetWR_RawJetP_Data/",{
            params :
                {
                    KFZ : KFZ,
                    STD : STD,
                    WLVT : WLVT,
                    ArchiveStat : ArchiveStat,
                }
        })

        return JRJsonData.data;

    },

    GetNotamImportantList : async () =>
    {

        const NotamImportantWordList = await http.instance.get("/schedule/GetNotamImportantWords");

        return NotamImportantWordList.data;

    },

    ///
    // arşiv durumu için problem yok direk alabiliriz.
    GetEFBReportFilesByflight : async (KFZ,STD,ArchiveId) =>
    {
        // alert(KFZ);
        // alert(STD);

        // alert(DeviceUID);
        // const verInfo = await http.instance.get("/Schedule/GetOccVersionsByKFZ", {params: {KeyForZip: KFZ}});
        // return verInfo.data;
        ArchiveId = 0;
        const reportFiles = await http.instance.get("/Report/GetFilesOfSelectedDeviceUID",{
            params :
                {
                    KFZ : KFZ,
                    STD : STD,
                    ArchiveId : ArchiveId
                    // DeviceUID : DeviceUID
                }
        });

        console.log("reportFiles2 reportFiles2 reportFiles2 reportFiles2")
        console.log(reportFiles.data)
        return reportFiles.data;

    }


    ///

};
export default ScheduleService;
